import { rankingItems } from "@/mocks/homeData";

export default function RankingSection() {
  const getRankBadge = (rank: number) => {
    if (rank === 1) return "bg-amber-500 text-background-50";
    if (rank === 2) return "bg-foreground-400 text-background-50";
    if (rank === 3) return "bg-amber-700 text-background-50";
    return "bg-background-200 text-foreground-500";
  };

  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            本周最受用户欢迎的高清影视内容排行榜
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-6 py-4 ${
                i < rankingItems.length - 1 ? "border-b border-background-200/50" : ""
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 font-label ${getRankBadge(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <span className="text-[11px] text-foreground-400">{item.category}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-500">{item.heat}</span>
                {item.trend === "up" && (
                  <i className="ri-arrow-up-line text-green-500 text-sm"></i>
                )}
                {item.trend === "new" && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-accent-100 text-accent-700 font-label">
                    NEW
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}